import React from 'react'
import PropTypes from 'prop-types'
import ArgosSearchBar from '@argos/search-bar'
import searchEncode from '../../helpers/searchEncode'
import sanitiseSearch from '../../helpers/sanitiseSearch'

import './SearchBar.scss'

class SearchBar extends React.Component {
  onSubmit (searchTerm) {
    const sanitisedSearchTerm = sanitiseSearch(searchTerm)
    window.location.href = '/help/search/' + searchEncode(sanitisedSearchTerm)
  }

  render () {
    const {
      position = 'top',
      searchHeader
    } = this.props

    const searchHeaderClass = searchHeader ? ' faq-search__header' : ''

    return (
      <div className={'faq-search ' + searchHeaderClass + ' faq-search--' + position}>
        <ArgosSearchBar large onSubmit={this.onSubmit} placeholder='Search for help' />
      </div>
    )
  }
}

SearchBar.propTypes = {
  position: PropTypes.string,
  searchHeader: PropTypes.bool
}

export default SearchBar
